export default __webpack_public_path__ + "static/media/complaint-issue-definitions.758c8491.pdf";